export default "__VITE_PUBLIC_ASSET__4f11a1d6__"